import React, { useEffect, useState } from 'react'
import { Outlet, useLocation, matchPath, Navigate } from 'react-router-dom'
import Header from '../components/Header/Header'
import SideBar from '../components/SideBar/SideBar'
import { SITE_LINKS_SCHEMA } from '../router/navlinks'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentSessionPages, getLoggedInUserInfo } from '../utils/services/auth'
import { userActions } from '../store/actions'
import { Loader } from '../components/Loader/Loader'
import { SessionExpiredModal } from '../components/Auth/SessionExpiredModal';
import { StyledMain, StyledSideBar } from '../AppThemeProvider'
const Main = () => {
  const { pathname } = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const { authInfo, accessibleRoutes = [],showSessionExpiry } = useSelector(store => store.user);
  const dispatch = useDispatch();
  const currentPath = accessibleRoutes.find(link => matchPath(link.path, pathname));
  const { title, requiresAuth,hideSideBar } = currentPath || {};
  const sidebar = useSelector(store=>store.user).sidebar;
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title])
  useEffect(() => {
    const savedInfo = getLoggedInUserInfo();
    const accessiblePages = getCurrentSessionPages();
    setIsAuthenticated(savedInfo ? true : false);
    dispatch(userActions.setAuthInfo(savedInfo));
    dispatch(userActions.setAccsibleRoutes(accessiblePages));
  }, [dispatch,pathname])
  if (isAuthenticated === null) {
    return <Loader />
  }
  if (isAuthenticated === false && authInfo === null && requiresAuth) {
    return <Navigate to={SITE_LINKS_SCHEMA.LOGIN} />
  }
  if (isAuthenticated && !currentPath) {
    return <Navigate to={SITE_LINKS_SCHEMA.FORBIDDEN} />
  }
  if(currentPath.path === "*"){
    return <Navigate to={ "/"} />
  }
  return (
    <section className='tma_app_content'>
      {
        requiresAuth && <>
          <header className='tma__app_header'>
            <Header />
          </header>
          {!hideSideBar && <StyledSideBar className='tma-app-sidebar' isOpen={sidebar}>
            <SideBar />
          </StyledSideBar>}
        </>
      }
      <StyledMain pageTitle={document.title}>
        <Outlet />
      </StyledMain>
      {showSessionExpiry && <SessionExpiredModal />}
    </section>

  )
}

export { Main }